export const FULL_VIEWPORT_HEIGHT_CSS = '100vh'

// The global header's height as zion-root measures it. Use it only to place
// something below the header itself; for "how much room is left", use
// CHROME_HEIGHT_CSS.
export const GLOBAL_HEADER_HEIGHT_CSS = 'var(--header-height, 61px)'

// Vertical space taken by the chrome above the content, in every mode, with no
// mode check: the chrome publishes its own height at runtime.
// - zion-root measures the global header into --header-height on its root
//   div, so it is 0px whenever the header is hidden (STATION, TWA, chromeless
//   routes).
// - The kiosk chrome sets --station-menu-height: the legacy StationMenu bar its
//   measured height, the floating ExperienceNavControls 0px (they displace no
//   layout). It is unset in WEB.
// Never hand-roll a px fallback for either: a guessed 42/60/64px leaves a gap
// or an overflow wherever that guess is wrong.
export const CHROME_HEIGHT_CSS = 'var(--station-menu-height, var(--header-height, 0px))'

// Height left for a full-height layout below the chrome. Usable directly in
// static css; the hook below is the same value for components.
export const AVAILABLE_VIEWPORT_HEIGHT_CSS = `calc(${FULL_VIEWPORT_HEIGHT_CSS} - ${CHROME_HEIGHT_CSS})`

export default function useAvailableViewportHeightCss() {
  return AVAILABLE_VIEWPORT_HEIGHT_CSS
}
